
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingPages/LocationInsightSubLandingPage",
      function () {
        return require("private-next-pages/landingPages/LocationInsightSubLandingPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingPages/LocationInsightSubLandingPage"])
      });
    }
  